import React, { Component } from 'react';
import injectSheet from 'react-jss';
import {
 Button, Form, FormGroup, Label, Input, Alert, Card, CardBody, CardFooter,
} from 'reactstrap';
import config from '../config';

const styles = {
  root: {
    background: '#fff',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '0.3125rem',
    minWidth: 400,
  },
  formGroup: {
    marginBottom: '1rem',
  },
  cardFooter: {
    background: "none",
    border: "none"
  },
  button: {
    width: "100%", 
    marginBottom: "1rem",
    background: "#34A5DA"
  }
};

export class Login extends Component {

  state = {
    errors: [],
    email: null, 
    password: null,
  }

  handleInput = (inputName) => (e) => {
    this.setState({
      [inputName]: e.target.value
    });
  }

  handleLogin = (e) => {
    const formData = new FormData();
    formData.append('email', this.state.email); 
    formData.append('password', this.state.password);
    
    fetch(`${config.backend.uri}/signin`, {
      method: 'POST', 
      body: JSON.stringify({
        email: this.state.email, 
        password: this.state.password
      }),
      headers:{
        'Content-Type': 'application/json'
      }
    }).then((res) => res.json())
    .then((res) =>{ 
      if (res.error) {
        this.setState({
          errors: [res.error]
        })
      } else {
        this.setState({
          errors: [],
        })
      }

      if (res.success && res.user && this.props.handleLogin) {
        this.props.handleLogin(res.user);
      }

      console.log('login', res)
    })
    .catch(err => { 
      console.error(err);
      this.setState({errors: ['Unable to sign in, please try again later']});
    });   
  }

  render() {
    const { classes, handleLogin } = this.props;
    return (
      <Card className={classes.root}>
        <Form>
          <CardBody>
              { !this.state.errors.length ? '' : this.state.errors.map((err, i) => <Alert key={i} color="danger">{err}</Alert>) }

              <FormGroup className={classes.formGroup}>
                <Label for="email">Email</Label>
                <Input onChange={this.handleInput("email")} type="email" name="email" />
              </FormGroup>

              <FormGroup>
                <Label for="password">Password</Label>
                <Input onChange={this.handleInput("password")} type="password" name="password" />
              </FormGroup>
          </CardBody>
          <CardFooter className={classes.cardFooter}>
            <Button color="primary" className={classes.button} onClick={this.handleLogin}>Log In</Button>
          </CardFooter>
        </Form>
      </Card>
    );
  }
}

export default injectSheet(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/LoginForm.js